"use client";

import Image from "next/image";
import { Link } from "@/i18n/navigation";
import { ReadMoreButton } from "@/components/ui/read-more-button";

interface FeaturedStoryProps {
	title: string;
	description: string;
	imageUrl: string;
	imageAlt: string;
	link: string;
	className?: string;
}

export function FeaturedStory({ 
	title, 
	description, 
	imageUrl, 
	imageAlt, 
	link, 
	className = "" 
}: FeaturedStoryProps) {
	return (
		<section className={`py-8 sm:py-16 bg-linear-to-t from-ss-blue/10 to-white ${className}`}>
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
					{/* Left Content */}
					<div className="lg:pr-8">
						<div className="mb-4">
							<span className="text-sm font-medium text-gray-600 uppercase tracking-wide">
								Featured story
							</span>
						</div>
						
						<h2 className="text-3xl lg:text-4xl font-bold mb-2 leading-tight text-gray-900">
							{title}
						</h2>
						
						<p className="text-lg text-gray-600 mb-8 leading-relaxed">
							{description}
						</p>
						
						<Link href={link}>
							<ReadMoreButton showArrow={false} size="lg" />
						</Link>
					</div>

					{/* Right Content - Image */}
					<div className="relative w-full max-w-[600px] h-[400px] lg:h-[500px]">
						<div className="rounded-2xl overflow-hidden w-full h-full shadow-lg">
							<Image
								src={imageUrl}
								alt={imageAlt}
								width={600}
								height={500}
								className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
							/>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
